import { BrowserRouter, Route, Routes } from "react-router-dom"
import "./App.css"
import LandingPage from "./pages/LandingPage"
import PrivacyPage from "./pages/PrivacyPage"

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy" element={<PrivacyPage />} />
        {/* One route for every step so the page keeps its state as the URL changes */}
        <Route path="/*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
